import React from 'react';
import './IRAAutoMaxTooManyDays.scss';
import Button from '../../Shared/Button/Button';

const IRAAutoMaxTooManyDaysModal = ({ closeModal }) => {
  return (
    <div>
      <h2 className="too-many-days-header">
        Please adjust your frequency selection.
      </h2>
      <div className="too-many-days-body">
        <p>
          Per month, the maximum number of days allowed for an IRA AutoMax
          program is 4.
        </p>
      </div>
      <Button
        id="too-many-days-notice-close"
        buttonType="primary"
        className="too-many-days-notice-close"
        onClick={() => {
          closeModal();
        }}
      >
        OK
      </Button>
    </div>
  );
};

export default IRAAutoMaxTooManyDaysModal;
